import React from 'react';
import { Wand2 } from 'lucide-react';

interface AICreateEntryProps {
  onClick: () => void;
  themeStyles: {
    surface: string;
    border: string;
    text: string;
    textDim: string;
  };
}

export function AICreateEntry({ onClick, themeStyles }: AICreateEntryProps) {
  return (
    <button
      onClick={onClick}
      className="group relative flex flex-col items-center gap-4 p-8 rounded-2xl hover:border-emerald-500 transition-all duration-300 min-w-[200px]"
      style={{
        background: themeStyles.surface,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: themeStyles.border,
      }}
    >
      <div className="w-20 h-20 rounded-2xl bg-emerald-500/20 flex items-center justify-center group-hover:bg-emerald-500/30 transition-colors">
        <Wand2 className="w-10 h-10 text-emerald-400 group-hover:text-emerald-300" />
      </div>
      <div className="text-center">
        <h3 className="text-xl font-semibold mb-1" style={{ color: themeStyles.text }}>AI Create</h3>
        <p className="text-sm" style={{ color: themeStyles.textDim }}>Auto-generate videos from footage</p>
      </div>
    </button>
  );
}
